import { SitemapNode } from "@salaxy/core";

/**
 * The additional root nodes that should be added in PRO site only
 * when the selected account is a Person: Household or Worker (in Raksa/Palkkamylly).
 */
export const sitemap_PersonLeafs: SitemapNode[] = [
  {
    title: "Laskelmat (henkilö)",
    url: "#/person-calc",
    id: "personCalc",
    roles: "person",
    children: [
      {
        title: "Viimeisimmät",
        url: "#/calc",
        id: "index",
      },
      {
        title: "Luonnokset",
        url: "#/calc/draft",
        id: "draft",
      },
      {
        title: "Lähetetyt",
        url: "#/calc/shared",
        id: "shared",
      },
      {
        title: "Palkkalaskelma",
        url: "#/calc/details/*",
        visibility: "hidden",
        id: "details",
      },
      {
        title: "Uusi laskelma",
        url: "#/calc/details/*/new-for-worker",
        visibility: "hidden",
        id: "newForWorker",
      },
      {
        title: "Laskelman kopio",
        url: "#/calc/details/*/copy-as-new",
        visibility: "hidden",
        id: "copyAsNew",
      },
      {
        title: "Työntekijälle maksetut",
        url: "#/person-calc/paid-worker",
        id: "paidWorker",
        roles: "person"
      },
      {
        title: "Kotitalouden maksamat",
        url: "#/person-calc/paid-household",
        id: "paidHousehold",
        roles: "person"
      },
      {
        title: "Työntekijän lähetetyt",
        url: "#/person-calc/sent",
        roles: "person",
        id: "sent",
      },
      {
        title: "Perutut ja virheet",
        url: "#/calc/error",
        roles: "person",
        id: "error",
      },
    ]
  },
  {
    title: "Raportit (henkilö)",
    url: "#/person-archive/employer-report",
    id: "reports",
    roles: "person",
    children: [
      {
        title: "Työnantajan maksamat palkat",
        url: "#/person-archive/employer-report",
        id: "personEmployerReport",
      },
      {
        title: "Kotitalousvähennys",
        url: "#/household-years/active",
        id: "householdYears",
        roles: "householdService",
        children: [
          {
            title: "Kotitalousvähennyksen tiedot",
            url: "#/household-years/details/*",
            visibility: "hidden",
            roles: "householdService",
            id: "details",
          },
        ],
      },
      {
        title: "Työntekijälle maksetut palkat",
        url: "#/person-archive/worker-report",
        id: "personWorkerReport",
      },
      {
        url: "#/reports/yearly-summary",
        id: "yearlySummary",
      },
      {
        url: "#/reports/pay-certificate",
        roles: "test",
        id: "payCertificate",
      },
      {
        title: "Laskut",
        url: "#/invoices",
        id: "invoices",
        children: [
          {
            title: "Laskun tiedot",
            url: "#/invoices/details/*",
            visibility: "hidden",
            id: "details",
          },
        ],
      },
      {
        title: "Palkkatietoilmoitukset",
        url: "#/irepr",
        children: [{
          title: "Palkkatietoilmoitus",
          url: "#/irepr/details/*",
        }],
      },
      {
        title: "Erillisilmoitukset",
        url: "#/irpsr",
        id: "irpsr",
        children: [{
          title: "Erillisilmoitus",
          url: "#/irpsr/details/*",
          id: "details",
        }],
      },
    ]
  },
  {
    title: "Asetukset (henkilö)",
    url: "#/person-account",
    id: "settings",
    roles: "person",
    children: [
      {
        title: "Omat tiedot",
        url: "#/person-account",
        id: "personAccount",
      },
      {
        url: "#/settings",
        id: "index",
      },
      {
        title: "Oma verokortti (työntekijä)",
        url: "#/person-taxcards/worker",
        id: "workerTaxcard",
      },
      {
        title: "Työntekijöiden verokortit",
        url: "#/person-taxcards/household",
        id: "householdTaxcards",
      },
      {
        url: "#/settings/pro-settings",
        roles: "test",
        id: "proSettings",
      },
      {
        url: "#/settings/service-settings",
        id: "serviceSettings",
      },
      {
        url: "#/settings/authorizations",
        id: "authorizations",
      },
      {
        title: "Asiakaspalvelu",
        id: "accountants",
        url: "#/settings/accountants",
      },
      {
        id: "accountReset",
        url: "#/settings/account-reset",
        roles: "test",
      },
    ]
  },
];